export enum RouteNames {
  root = 'root',
  login = 'login',
  accountRequest = 'accountRequest',
  forgotPassword = 'forgotPassword',
  resetPassword = 'resetPassword',

  barcodeScanner = 'barcodeScanner',
  favouriteCustomerOrderList = 'favouriteCustomerOrderList',
  home = 'home',
  orderConfirmed = 'orderConfirmed',
  vtOrderConfirmed = 'vtOrderConfirmed',
  orderDetail = 'orderDetail',
  vtOrderDetail = 'vtOrderDetail',
  orderHistory = 'orderHistory',
  vtOrderHistory = 'vtOrderHistory',
  partner = 'partner',
  productActions = 'productActions',
  productDetail = 'productDetail',
  promoProductDetail = 'promoProductDetail',
  productPriceUpdates = 'priceUpdates',
  products = 'products',
  mcpSettings = 'mcpSettings',
  profile = 'profile',
  vtShoppingCart = 'vtShoppingCart',
  vtCheckout = 'vtCheckout',
  shoppingCart = 'shoppingCart',
  userDetail = 'userDetail',
  users = 'users',
  promoAssortment = 'promoAssortment',
  promos = 'promos',
  promoDetail = 'promosDetail',
}
